import { render, staticRenderFns } from "./alternating-details.vue?vue&type=template&id=812ef496&scoped=true&"
import script from "./alternating-details.vue?vue&type=script&lang=js&"
export * from "./alternating-details.vue?vue&type=script&lang=js&"
import style0 from "./alternating-details.vue?vue&type=style&index=0&id=812ef496&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812ef496",
  null
  
)

export default component.exports